import { render, staticRenderFns } from "./ApexChart.vue?vue&type=template&id=31224542&scoped=true"
import script from "./ApexChart.vue?vue&type=script&lang=js"
export * from "./ApexChart.vue?vue&type=script&lang=js"
import style0 from "./ApexChart.vue?vue&type=style&index=0&id=31224542&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31224542",
  null
  
)

export default component.exports